import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Divider, Theme } from '@mui/material';
import DetectionColumn from './DetectionColumn';
import Categories from './Categories';
import Alerts from './Alerts';

const DetectionComponent: FC<
  React.PropsWithChildren<DetectionComponentProps>
> = props => {
  const { classes } = useStyles();
  const { coveredCategories, uncoveredCategories, preventCategories } = props;
  return (
    <div className={classes.detectionContainer}>
      <DetectionColumn header='Not Covered'>
        {uncoveredCategories && <Categories data={uncoveredCategories} />}
      </DetectionColumn>

      <Divider orientation='vertical' sx={{ mr: 1 }} />

      <DetectionColumn header='Monitor'>
        {coveredCategories && <Categories data={coveredCategories} />}
      </DetectionColumn>

      <Divider orientation='vertical' sx={{ mr: 1 }} />

      <DetectionColumn header='Alert'>
        <Alerts />
      </DetectionColumn>

      <Divider orientation='vertical' sx={{ mr: 1 }} />

      <DetectionColumn header='Prevent'>
        {preventCategories && <Categories data={preventCategories} />}
      </DetectionColumn>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  detectionContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
}));

export interface DetectionComponentProps {
  coveredCategories?: string[];
  uncoveredCategories?: string[];
  preventCategories?: string[];
}

export default DetectionComponent;
